class SmbProductGallery {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-smb-gallery-track]');
    this.slides = [...root.querySelectorAll('[data-smb-gallery-slide]')];
    this.thumbs = [...root.querySelectorAll('[data-smb-gallery-thumb]')];
    this.count = root.querySelector('[data-smb-gallery-count]');
    this.index = 0;
    if (this.slides.length < 2) return;
    root.querySelector('[data-smb-gallery-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    root.querySelector('[data-smb-gallery-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.go(index)));
    this.track.addEventListener('scroll', () => {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => {
        const nextIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.setActive(nextIndex);
      }, 80);
    }, { passive: true });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.go(this.index - 1);
      if (event.key === 'ArrowRight') this.go(this.index + 1);
    });
  }

  go(index) {
    const next = (index + this.slides.length) % this.slides.length;
    this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
    this.setActive(next);
  }

  setActive(index) {
    this.index = Math.max(0, Math.min(index, this.slides.length - 1));
    this.thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === this.index);
      thumb.setAttribute('aria-current', thumbIndex === this.index ? 'true' : 'false');
    });
    if (this.count) this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
  }
}

document.querySelectorAll('[data-smb-product-gallery]').forEach((gallery) => new SmbProductGallery(gallery));
